import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function FailedAttemptsSection() {
  const attempts = ['Los métodos anglosajones de "llanto libre" (Cry It Out) se sienten fríos, crueles y van en contra de tu instinto de protección.', 'Has seguido consejos aislados de redes sociales que funcionan una noche pero fallan la siguiente porque no atacan la raíz biológica.', 'Intentas "cansar al bebé" durante el día, lo que genera cortisol y hace que su cerebro esté demasiado alterado para entrar en sueño profundo.', 'No tienes a la "tribu" (abuela o tías) cerca para relevarte, y tratas de forzar al bebé a seguir tu ritmo de trabajo en lugar de respetar su reloj biológico.'];
  return <section className="py-24 px-4 bg-navy-800" data-id="element-30">
      <div className="max-w-4xl mx-auto" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-32">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-cream-50 mb-4" data-id="element-33">
            Por qué lo que has intentado no funciona
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-34">
          {attempts.map((attempt, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-navy-900 p-6 rounded-xl border border-red-900/30 flex items-start space-x-4" data-id="element-35">
              <XCircleIcon className="w-6 h-6 text-red-400/80 flex-shrink-0 mt-1" data-id="element-36" />
              <p className="text-cream-100/80 font-body text-base leading-relaxed" data-id="element-37">
                {attempt}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}